import { render, staticRenderFns } from "./FormGoal.vue?vue&type=template&id=b8d17fb4&scoped=true&"
import script from "./FormGoal.vue?vue&type=script&lang=js&"
export * from "./FormGoal.vue?vue&type=script&lang=js&"
import style0 from "./FormGoal.vue?vue&type=style&index=0&id=b8d17fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d17fb4",
  null
  
)

export default component.exports